'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';

import { Link } from 'src/general/components/Link/Link';
import { Shade } from 'src/general/components/Shade/Shade';

type Props = {
  'data-testid'?: string;
  title?: string;
} & (
  | {
      href: string;
      prefetch?: boolean;
    }
  | {
      onClick?: () => void;
      popovertarget?: string;
    }
);

const desktopClasses = clsx(
  'c-shade_container relative flex size-10 cursor-pointer items-center justify-center overflow-hidden rounded-full bg-transparent p-1.5 transition-colors duration-200',
  // Styles override for the homepage
  'group-has-[.header-homepage]/body:group-[.scroll-top]/body:hover:bg-sta-on-inv-hov',
);

export const HeaderMenuAction: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  if ('href' in props) {
    return (
      <Link {...props} className={desktopClasses}>
        <Shade noBackground />
        {children}
      </Link>
    );
  }
  return (
    <button {...props} className={desktopClasses}>
      <Shade noBackground />
      {children}
    </button>
  );
};
